
import { Helmet } from "react-helmet-async";
import "./styles.css";
import React, { useState } from "react";

const PAYPAL_LINK = "https://www.paypal.me/Kevin222316/20";
const PAYPAL_LINK1 = "https://www.paypal.me/Kevin222316/40";
const CASH_APP_LINK = "https://cash.app/$KevinRispoli";

const bracelets = [
  {
    name: "Stay Spooky Bracelet",
    image: `${process.env.PUBLIC_URL}/images/merch/bracelet-stayspooky.jpg`,
  },
  {
    name: "Knowall Paranormal (KAP) Gold Bracelet",
    image: `${process.env.PUBLIC_URL}/images/merch/bracelet-kap-gold.jpg`,
  },
  {
    name: "Knowall Paranormal (KAP) Silver Bracelet",
    image: `${process.env.PUBLIC_URL}/images/merch/bracelet-kap-silver.jpg`,
  },
  {
    name: "T’s Talk Bracelet",
    image: `${process.env.PUBLIC_URL}/images/merch/bracelet-tt.jpg`,
  },
  {
    name: "Kevin’s Korner Bracelet",
    image: `${process.env.PUBLIC_URL}/images/merch/bracelet-kk.jpg`,
  },
];

const shirts = [
    
  {
    name: "Men’s Black Shirt",
    image: `${process.env.PUBLIC_URL}/images/merch/mens-b.jpg`,
  },
  {
    name: "Men’s White Shirt",
    image: `${process.env.PUBLIC_URL}/images/merch/mens-w.jpg`,
  },
  {
    name: "Women’s Black Shirt",
    image: `${process.env.PUBLIC_URL}/images/merch/womens-b.jpg`,
  },
  {
    name: "Women’s White Shirt",
    image: `${process.env.PUBLIC_URL}/images/merch/womens-w.jpg`,
  },
  {
  name: "Men’s Black Long Sleeve Shirt",
  image: `${process.env.PUBLIC_URL}/images/merch/mens-long-sleeve-b.jpg`,
},
{
  name: "Men’s White Long Sleeve Shirt",
  image: `${process.env.PUBLIC_URL}/images/merch/mens-long-sleeve-w.jpg`,
},
];


function MerchPage() {
     const [selectedImage, setSelectedImage] = useState(null);
  return (
    <>
      <Helmet>
        <title>Merch | Knowall Paranormal</title>
      </Helmet>
      

      <div className="page-container">
        <section className="section">
          <h1 className="section-title">Official Merch</h1>
          <p className="section-description">
            Support Knowall Paranormal with official gear.
          </p>
               <section className="section">
    <p className="section-description" style={{ color: "#39ff14", fontWeight: "bold" }}>
  ⚠️ IMPORTANT: Before completing payment, add a note in PayPal or Cash App and include:
</p>

<ul style={{ textAlign: "center", listStyle: "none", padding: 0 }}>
   <li> Your full name </li>
   <li>• Item name (e.g. "Stay Spooky Bracelet" or "Men’s Black Shirt")</li>
   <li>• Shirt size and color (if ordering a shirt)</li>
   <li>• Shipping address</li>
</ul>
        </section>
          <p className="section-description" style={{ color: "#39ff14" }}>
             U.S. Shipping Only
          </p>
          
        </section>

        {/* BRACELETS */}
        <section className="section">
          <h2 className="section-title">Handmade Bracelets</h2>
          <p className="section-description">
  Each bracelet is handmade and inspected before shipping.
</p>

          <div className="merch-grid">
            {bracelets.map((item) => (
              <div className="merch-card" key={item.name}>
               <img
  src={item.image}
  alt={item.name}
  className="merch-card-image"
  onClick={() => setSelectedImage(item.image)}
  style={{ cursor: "pointer" }}
/>
                <h3>{item.name}</h3>
                <p className="merch-price">$20</p>

                <div className="payment-buttons">
                  <a
                    href={PAYPAL_LINK}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-primary"
                  >
                    Buy with PayPal
                  </a>
                  <a
                    href={CASH_APP_LINK}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-cashapp"
                  >
                    Buy with Cash App
                  </a>
                </div>
              </div>
            ))}
          </div>
        </section>
        <p className="section-description" style={{ color: "#ff4444" }}>
  ⚠️ Limited handmade bracelets — small batch only
</p>

        {/* SHIRTS */}
        <section className="section">
          <h2 className="section-title">Shirts</h2>

          <div className="merch-grid">
            {shirts.map((item) => (
              <div className="merch-card" key={item.name}>
                <img
  src={item.image}
  alt={item.name}
  className="merch-card-image"
  onClick={() => setSelectedImage(item.image)}
  style={{ cursor: "pointer" }}
/>
                <h3>{item.name}</h3>
                <p className="merch-price">$40</p>

                <div className="payment-buttons">
                  <a
                    href={PAYPAL_LINK1}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-secondary"
                  >
                    Order with PayPal
                  </a>
                  <a
                    href={CASH_APP_LINK}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-cashapp"
                  >
                    Order with Cash App
                  </a>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* ORDER NOTE */}
        <section className="section">
    <p className="section-description" style={{ color: "#39ff14", fontWeight: "bold" }}>
  ⚠️ IMPORTANT: Before completing payment, add a note in PayPal or Cash App and include:
</p>

<ul style={{ textAlign: "center", listStyle: "none", padding: 0 }}>
   <li> Your full name </li>
   <li>• Item name (e.g. "Stay Spooky Bracelet" or "Men’s Black Shirt")</li>
   <li>• Shirt size and color (if ordering a shirt)</li>
   <li>• Shipping address</li>
</ul>
        </section>
        {selectedImage && (
  <div className="image-modal" onClick={() => setSelectedImage(null)}>
    <img src={selectedImage} alt="Zoomed" className="image-modal-content" />
  </div>
)}
      </div>
    </>
  );
}

export default MerchPage;
